import React from "react";
import {getManager} from "../../../ts/manager/Manager";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import StateViewController from "../../vc/StateViewController";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import AppButton from "../../element/button/AppButton";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import {INavButtonProps} from "../../element/button/IButton";

const HeaderStructure = (props:IRouteProps) =>
{

    const viewState = StateViewController({
        routeProps: props,
        redirectOnLogout: true
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    const utilityNavChoiceList:(RouteChoice|INavButtonProps)[] = getManager().ui.getUtilityNavChoiceList();
    const browseRouteModel = getModelFactory().browseRoute.getDefaultModel();
    const primaryMenuChoiceList:(RouteChoice|INavButtonProps)[] = browseRouteModel.uiChoiceList();
    const menuChoiceList:(RouteChoice|INavButtonProps)[] = primaryMenuChoiceList.concat(utilityNavChoiceList);
    const homepageChoice:RouteChoice|null = browseRouteModel.choices.homepage ?? null;

    const onMobileNavToggle = () =>
    {
        if (!document.documentElement.classList.contains("nav-is-open"))
        {
            document.documentElement.classList.add("nav-is-open");
        } else {
            document.documentElement.classList.remove("nav-is-open");
        }
    }

    return <>
        <aside className="pre-header" id="pre-header">
            <div className="container h-100">
                <div className="row h-100 d-flex align-items-center">
                    <div className="col-1 col-md-2">

                        <div id="searchToggler" className="search-trigger">
                            <i className="fas fa-search" aria-hidden="true"></i>
                            <span className="visually-hidden">Open Search Bar</span>
                        </div>

                    </div>
                    <div className="col-11 col-md-10 text-end right text-right">


                        <nav role="navigation" className="h-100" aria-label="Utility and Auxiliary">
                            <ul className="nav-icons">

                                {utilityNavChoiceList.map((choice, index) =>
                                {
                                    return <li key={index}>
                                        {choice instanceof RouteChoice ?

                                            <RouteChoiceButton
                                                routeChoice={choice}
                                            /> :
                                            <AppButton
                                                {...choice}
                                            />
                                        }
                                    </li>
                                })}


                            </ul>
                        </nav>

                    </div>
                </div>
            </div>
        </aside>
        <header id="site-header">
            <div className="primary-menu-area">
                <div className="container h-100">
                    <div className="nav-wrap h-100 d-flex align-items-center">
                        <div className="col-9 col-lg-2">
                            <div className="logo">
                                <RouteChoiceButton routeChoice={homepageChoice} >
                                    <img
                                        width="240"
                                        height="38"
                                        className="ignore-html fixed-logo"
                                        src="/img/logo/svg-logo/logo-black.svg?v=1"
                                        alt={getManager().app.site.title}
                                        title={getManager().app.site.title + " Homepage"}
                                    />
                                </RouteChoiceButton>
                            </div>
                        </div>
                        <div className="col-3 d-lg-none justify-content-end text-end" aria-hidden="true">
                            <div
                                className="navicon"
                                id="mobile-nav-toggle"
                                aria-hidden="true"
                                onClick={onMobileNavToggle}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 align-self-end justify-content-end">
                            <nav id="primary-nav" aria-label="Primary">
                                <ul className="menu-items">

                                    {primaryMenuChoiceList.map((choice, index) =>
                                    {
                                        return <li className="menu-item menu-item-type-post_type menu-item-object-page" key={index}>

                                            {choice instanceof RouteChoice ?

                                                <RouteChoiceButton
                                                    routeChoice={choice}
                                                    className="primary-link"
                                                /> :
                                                <AppButton
                                                    {...choice}
                                                    className="primary-link"
                                                />
                                            }
                                        </li>;
                                    })}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

        </header>
    </>
}
export default HeaderStructure;